import styled from "@emotion/styled"
import { PBanner } from "@porsche-design-system/components-react"
import type { PropsWithChildren } from "react"
import { useCallback, useState } from "react"
import { defineMessages, useIntl } from "react-intl"
import type { ErrorMessage } from "src/types/ErrorMessage"
import { ErrorBannerContext } from "./ErrorBannerContext"

const messages = defineMessages({
	errorTitle: {
		defaultMessage: "Error",
		id: "error.banner.title",
	},
})

export const ErrorBannerProvider = ({ children }: PropsWithChildren) => {
	const [error, setError] = useState<ErrorMessage | undefined>()
	const { formatMessage } = useIntl()

	const handleDismissed = useCallback(() => setTimeout(() => setError(undefined), 500), [])

	return (
		<ErrorBannerContext.Provider value={{ showError: setError }}>
			{error && (
				<StyledBanner
					state="error"
					heading={formatMessage(messages.errorTitle)}
					open
					description={error.message}
					onDismiss={handleDismissed}
				/>
			)}
			{children}
		</ErrorBannerContext.Provider>
	)
}

const StyledBanner = styled(PBanner)`
	z-index: 100000;
`
